<template>
  <Teleport to="body">
    <div
      class="fixed left-0 right-0 top-0 z-[999] flex h-screen flex-col items-center justify-center overflow-y-auto overflow-x-hidden bg-black/50 p-6">
      <div
        class="flex relative p-5 w-auto bg-white rounded-lg shadow-md min-w-96 max-h-[90vh] overflow-hidden">
        <div class="flex flex-col justify-center w-full bg-white rounded-lg">
          <div class="flex flex-col mb-3.5">
            <button type="button" class="self-end" @click="$emit('primaryButtonClicked')">
              <Icon icon="mdi-close" class="w-6 h-6"></Icon>
            </button>
            <div v-if="title" class="text-2xl font-medium" :class="titleStyle">{{ title }}</div>
          </div>
          <slot>
            <div class="text-gray-700 select-none text-md overflow-y-auto pr-2 max-h-[60vh]">
              <slot name="content"> {{ text }}</slot>
            </div>
          </slot>
          <div class="flex gap-4 mt-6 ml-auto h-8 font-medium">
            <BaseButton
              v-if="primaryButtonText"
              outline
              class="w-20 h-8 capitalize border-0"
              @click.prevent="$emit('primaryButtonClicked')"
              >{{ primaryButtonText }}</BaseButton
            >

            <BaseButton
              v-if="secondaryButtonText"
              class="w-20 h-8 capitalize"
              @click.prevent="$emit('secondaryButtonClicked')"
              >{{ secondaryButtonText }}</BaseButton
            >
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue';
import BaseButton from './BaseButton.vue';
defineProps<{
  title?: string;
  titleStyle?: string;
  text?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}>();

defineEmits(['secondaryButtonClicked', 'primaryButtonClicked']);
</script>
